import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProvidersService } from '../../providers.service';

@Component({
  selector: 'app-all-pricelists',
  templateUrl: './all-pricelists.component.html',
  styleUrls: ['./all-pricelists.component.scss']
})
export class AllPricelistsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  columnDefs
  rowData: any = [];
  rowSelection;
  private gridApi;
  private gridColumnApi;
  searchValue;
  showSelectedPricelist: boolean = false;
  showDeleteProvider: boolean = false;
  selectedRows: any;
  updatePricelistForm: FormGroup;
  isPricelistGrid :boolean = true;
  initialName = new FormControl();

  constructor(private providerService: ProvidersService, private fb: FormBuilder) {
    super();
    this.getPricelsitDetails();
    this.updatePricelistForm = this.fb.group({
      priceListName : new FormControl('', Validators.required),
      priceListStatus : new FormControl('', Validators.required),
      priceListType : new FormControl('', Validators.required),
    })
  }
  getPricelsitDetails() {
    this.providerService.getAllPricelistsForGrid().subscribe(res => {
      console.log(res);
      if (res['httpcode'] == 200) {
        this.setGrid(res['data'])
        this.isPricelistGrid = true
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'single';
    this.columnDefs = [
      { field: '', headerName: 'Action', width: 130, checkboxSelection: true },
      { field: 'priceListName', headerName: 'Pricelist Name', width: 300, sort: "desc" },
      { field: 'priceListStatus', headerName: 'Pricelist Status', width: 250,  },
      { field: 'priceListType', headerName: 'Pricelist Type', width: 180 },

    ]
  }
  get f() {
    return this.updatePricelistForm.controls;
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != []) {
      this.showSelectedPricelist = true;
      this.updatePricelistForm.patchValue({
        priceListName: this.selectedRows[0].priceListName,
        priceListStatus: this.selectedRows[0].priceListStatus,
        priceListType: this.selectedRows[0].priceListType,
      })
      this.initialName.setValue(this.selectedRows[0].priceListName)
    }

  }

  editPricelist(){
    this.isPricelistGrid = false;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  exportData() {
    this.gridApi.exportDataAsCsv();//Done
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }


  onSubmitUpdatePricelist(){
    
    const formData = {
      "newPriceListName": this.f.priceListName.value,
      "priceListName": this.selectedRows[0].priceListName,
      "priceListStatus": this.f.priceListStatus.value,
      "priceListType": this.selectedRows[0].priceListType
    }
    this.providerService.updateProductPricelist(formData).subscribe(res =>{
      if(res['httpcode'] == 200 && res.responseStatus === 'Success'){
        this.toastrService.success('Pricelist updated', 'Success')
        this.getPricelsitDetails();
      }
    })
    
  }
}
